<template>
  <b-modal id="modal-ajustar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Ajustar tempo de acesso</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-ajustar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <div class="row">
        <div class="col-12 col-md-12">
            <div class="form-group">
              <label for="fonte">Curso</label>
              <form-group id="plano" label="curso" label-class="sr-only" :text="{ required: 'Obrigatório selecionar o curso' }" :field="$v.usuario.idAssinatura">
                <select class="form-control" v-model="assinatura">
                  <option v-for="assinatura in assinaturas" :key="assinatura.idAssinatura" :value="assinatura">{{ assinatura.plano }}</option>
                </select>
              </form-group>
            </div>
          </div>
        <div class="col-12" v-if="usuario.idAssinatura">
          <form-group id="nome" label="Data de Expiração *" :text="{ required: 'Obrigatório informar a data de expiração' }" :field="$v.usuario.dataCancelamento">
            <input type="date" class="form-control" id="nome" v-model="usuario.dataCancelamento"/>
          </form-group>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="ajustarTempoAcesso">Salvar</button>
          <button class="btn btn-primary mr-3" v-if="(assinaturas.length > 1 && empresaId === 25)" type="button" @click="excluirAssinatura(assinatura)">Excluir</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-ajustar')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import UsuarioAPI from '@/api/usuario-api'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import PlanoAPI from '@/api/plano-api'
import EmpresaUtils from '@/core/util/empresa-utils'
import DateUtils from '@/core/util/date-utils'

export default {
  name: 'ModalAjustaTempoAcesso',
  props: {
    usuarioEdicao: Object
  },
  components: {
    FormGroup
  },
  data () {
    return {
      usuario: {
        dataCancelamento: null,
        idAssinatura: null,
        id: null
      },
      assinaturas: [],
      assinatura: null,
      empresaId: EmpresaUtils.getEmpresa().id
    }
  },
  watch: {
    assinatura () {
      if (this.assinatura) {
        if (this.assinatura.data_cancelamento) {
          this.usuario.dataCancelamento = DateUtils.dateTimeToDate(this.assinatura.data_cancelamento)
        } else {
          this.usuario.dataCancelamento = null
        }
        this.usuario.idAssinatura = this.assinatura.idAssinatura
      }
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
      if (modalId === 'modal-ajustar') {
        this.$v.$reset()
        this.assinaturas = []
        this.assinatura = null
        this.usuario.id = this.usuarioEdicao.id
        this.usuario.dataCancelamento = null
        this.usuario.idAssinatura = null
        this.assinaturas = await PlanoAPI.listarPorUsuarioDaEmpresa(this.usuarioEdicao.id)
      }
    })
  },

  validations: {
    usuario: {
      dataCancelamento: { required },
      idAssinatura: { required }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-ajustar')
    },
    ajustarTempoAcesso: function () {
      this.$v.usuario.$touch()
      if (!this.$v.usuario.$invalid) {
        const loader = this.$loading.show()
        this.usuario.dataCancelamento = this.usuario.dataCancelamento + ' 00:00:00'
        UsuarioAPI.ajustarTempoDeAcesso(this.usuario).then(data => {
          loader.hide()
          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Tempo de acesso ajustado com sucesso'
          }).then(() => {
            this.$bvModal.hide('modal-ajustar')
            this.$emit('usuarioSalvo', this.usuario)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    },
    excluirAssinatura: function (assinatura) {
      Swal.fire({
        title: 'Você deseja excluir essa assinatura?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir assinatura!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.excluirAssinatura(assinatura).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Assinatura excluída com sucesso'
            }).then(() => {
              PlanoAPI.listarPorUsuarioDaEmpresa(this.usuarioEdicao.id).then(data => {
                this.assinaturas = data
              })
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
          loader.hide()
        }
      })
    }
  }
}
</script>
